<div class="annual-sales-objectives modal">
  <div class="modal">
    <div class="modal__top">
      <span class="modal__title"> {{ 'ANNUAL_SALES_CHART.ENTER_OBJECTIVES' | i18nextEager | uppercase }}</span>
      <span class="modal__click" (click)="closeDialog()">
        <img src="/assets/icons/close_modal.svg" alt="" />
      </span>
    </div>
    <form class="form">
      <div class="modal__body">
        <div class="modal__input modal__input__inline">
          <label>{{ 'ANNUAL_SALES_CHART.CONSUMPTION' | i18nextEager | uppercase }}</label>
          <input
            matInput
            name="objConsumption"
            [(ngModel)]="data.objConsumption"
            maxlength="3"
            (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
            cdkFocusInitial
          />
          <span matSuffix class="suffix-icon">
            MWh
          </span>
        </div>
        <div class="modal__input modal__input__inline">
          <label>{{ 'ANNUAL_SALES_CHART.COMMERCIAL_MARGIN' | i18nextEager | uppercase }}</label>
          <input
            matInput
            name="objMargin"
            [(ngModel)]="data.objMargin"
            maxlength="3"
            (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
          />
          <span matSuffix class="suffix-icon">
            €/MWh
          </span>
        </div>
      </div>
      <div class="modal__footer">
        <button class="secondary" type="reset" (click)="closeDialog()" cdkFocusInitial>
          {{ 'COMMONS.CANCEL' | i18nextEager }}
        </button>
        <button class="primary" [mat-dialog-close]="data" [disabled]="data.objConsumption <= 0 || data.objMargin <= 0">
          {{ 'COMMONS.SAVE' | i18nextEager }}
        </button>
      </div>
    </form>
  </div>
</div>
